import { GroupOption } from "../../types";

export const groupOptions: GroupOption[] = [
	{
		label: "Items By Customer POs",
		type: "Group",
		pageSlugs: {
			pageSlug: "inventory",
			subtablePageSlug: "inventory_items",
		},
		tableSlugs: {
			primaryTableSlug: "purchase-orders",
			nestedTableSlug: "items-for-purchase-orders",
			subtableSlug: "sales-orders-item-uuid",
		},
		groupModalOptions: {
			primaryOption: {
				text: "Items",
				icon: "box",
				weight: "regular",
				textColor: "text-supply-blue-600",
				badgeColor: "bg-supply-blue-50",
			},
			secondaryOption: {
				text: "Customer POs",
				icon: "receipt",
				weight: "regular",
				textColor: "text-indigo-600",
				badgeColor: "bg-indigo-50",
			},
		},
		urlKeys: {
			key: "purchase-orders:items-for-purchase-orders",
			checkKey: "items-for-purchase-orders",
			nestedPrimaryRecordSlug: "SalesOrders",
		},
		isDefault: true,
		showMenu: true,
		uuid: "94f1e621-6eb4-bece-7f67-302ed49bce88",
		tableDisplayData: {
			hasInfiniteScroll: false,
			leftLockedColumns: 2,
			isNestedTable: false,
			hasNestedTable: true,
			suffixColumnIndexes: [-1],
			tableSlug: "purchase-orders",
			tableType: "primary",
			leftOffset: 219,
			nestedTable: {
				hasInfiniteScroll: true,
				leftLockedColumns: 2,
				isNestedTable: true,
				suffixColumnIndexes: [-1],
				tableSlug: "items-for-purchase-orders",
				tableType: "nested",
				leftOffset: 135,
				hasCellExpansion: [0],
			},
			subTableParent: {
				hasInfiniteScroll: false,
				isNestedTable: false,
				suffixColumnIndexes: [-1],
				tableSlug: "units-for-items-for-purchase-orders",
				tableType: "subTableParent",
				leftOffset: 135,
				subTableChild: {
					hasInfiniteScroll: true,
					isNestedTable: false,
					suffixColumnIndexes: [-1],
					tableSlug: "units-for-items-for-purchase-orders",
					tableType: "subTableChild",
					leftOffset: 135,
				},
			},
		},
	},
	{
		label: "Customer POs By Items",
		type: "Group",
		pageSlugs: {
			pageSlug: "inventory",
			subtablePageSlug: "inventory_items",
		},
		tableSlugs: {
			primaryTableSlug: "inventory_items-customerPos",
			alternativePrimaryTableSlug: "inventory_items",
			nestedTableSlug: "purchase-orders_items",
			subtableSlug: "units-for-items-for-purchase-orders",
		},
		groupModalOptions: {
			primaryOption: {
				text: "Customer POs",
				icon: "receipt",
				weight: "regular",
				textColor: "text-indigo-600",
				badgeColor: "bg-indigo-50",
			},
			secondaryOption: {
				text: "Items",
				icon: "box",
				weight: "regular",
				textColor: "text-supply-blue-600",
				badgeColor: "bg-supply-blue-50",
			},
		},
		urlKeys: {
			key: "inventory_items:purchase-orders_items",
			checkKey: "purchase-orders_items",
			nestedPrimaryRecordSlug: "PurchaseOrderItems",
		},
		isDefault: false,
		showMenu: true,
		uuid: "904cc7b1-ad50-426b-b64f-87bb23d0a93a",
		tableDisplayData: {
			hasInfiniteScroll: false,
			leftLockedColumns: 2,
			isNestedTable: false,
			hasNestedTable: true,
			suffixColumnIndexes: [-1],
			tableSlug: "inventory_items",
			tableType: "primary",
			leftOffset: 219,
			hasCellExpansion: [0],
			nestedTable: {
				hasInfiniteScroll: false,
				leftLockedColumns: 2,
				isNestedTable: true,
				suffixColumnIndexes: [-1],
				tableSlug: "inventory_items",
				tableType: "nested",
				leftOffset: 0,
			},
			subTableParent: {
				hasInfiniteScroll: false,
				leftLockedColumns: 2,
				isNestedTable: true,
				suffixColumnIndexes: [-1],
				tableSlug: "inventory_items",
				tableType: "subTableParent",
				leftOffset: 0,
				subTableChild: {
					hasInfiniteScroll: false,
					leftLockedColumns: 2,
					isNestedTable: true,
					suffixColumnIndexes: [-1],
					tableSlug: "inventory_items",
					tableType: "subTableChild",
					leftOffset: 0,
				},
			},
		},
	},
	// {
	// 	label: "Show All Items",
	// 	type: "Show All",
	// 	pageSlugs: {
	// 		pageSlug: "inventory",
	// 		subtablePageSlug: "inventory_items",
	// 	},
	// 	tableSlugs: {
	// 		primaryTableSlug: "inventory_items",
	// 		nestedTableSlug: "",
	// 		subtableSlug: "units-for-items-for-purchase-orders",
	// 	},
	// 	groupModalOptions: {
	// 		primaryOption: {
	// 			text: "Items",
	// 			icon: "box",
	// 			weight: "regular",
	// 			textColor: "text-supply-blue-600",
	// 			badgeColor: "bg-supply-blue-50",
	// 		},
	// 		secondaryOption: null,
	// 	},
	// 	urlKeys: null,
	// 	isDefault: false,
	// 	showMenu: true,
	// 	uuid: "1c6c36dc-100a-4618-99b2-8957bc403161",
	// },
	// {
	// 	label: "Show All Units",
	// 	type: "Show All",
	// 	pageSlugs: {
	// 		pageSlug: "inventory",
	// 		subtablePageSlug: "inventory_items",
	// 	},
	// 	tableSlugs: {
	// 		primaryTableSlug: "inventory",
	// 		nestedTableSlug: "",
	// 		subtableSlug: "",
	// 	},
	// 	groupModalOptions: {
	// 		primaryOption: {
	// 			text: "Units",
	// 			icon: "boxesStacked",
	// 			weight: "regular",
	// 			textColor: "text-mauve-600",
	// 			badgeColor: "bg-mauve-100",
	// 		},
	// 		secondaryOption: null,
	// 	},
	// 	urlKeys: null,
	// 	isDefault: false,
	// 	showMenu: true,
	// 	uuid: "9b49e2a8-bd2f-4689-b49e-65857dc980a6",
	// },
];
